<template>
  <div :class="fieldStyling">
    <div class="field__label flex items-center justify-between">
      <FieldLabel :field="field" />
      <ErrorMessage
        v-if="hasErrors"
        :error="errorMessage"
      />
    </div>
    <FlatPickr
      v-model="value"
      :class="{ 'error': hasErrors }"
      :config="datepickerConfig"
      :disabled="isDisabled"
    />
    <HelpText
      v-if="field.attributes.help"
      :help-text="field.attributes.help"
    />
  </div>
</template>

<script type="text/babel">
import HelpText from './HelpText'
import FieldLabel from './FieldLabel'
import ErrorMessage from './ErrorMessage'
import FlatPickr from 'vue-flatpickr-component'
import inputField from 'FormBuilder/Resources/assets/js/mixins/input-field.js'

export default {
  name: 'DateTimeField',
  components: {
    FlatPickr,
    FieldLabel,
    ErrorMessage,
    HelpText,
  },
  mixins: [inputField],
  data() {
    return {
      datepickerConfig: {
        enableTime: true,
        altFormat: (this.$date.flatPickerDateFormat() ?? this.flatPickerDateFormat) + ' H:i:S',
        altInput: true,
        dateFormat: this.$date.isoFormat(),
        allowInput: true,
      },
    }
  },
  computed: {
    hasErrors(){
      return this.errors.length > 0
    },
  },
}
</script>
